"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function hight(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M19.8319 7.71152L13.4906 18.1665H9.70912L12.6154 13.3688H9.72713L6.35963 18.9218C7.96489 20.2267 9.97346 20.9337 12.0422 20.922C14.1109 20.9103 16.1113 20.1806 17.7017 18.8577C19.2921 17.5347 20.3738 15.7005 20.7619 13.6685C21.15 11.6365 20.8205 9.53276 19.8296 7.71677L19.8319 7.71152ZM14.2954 5.83502L11.5429 10.365H14.4349L17.6404 5.07827C16.0351 3.77335 14.0265 3.06633 11.9578 3.07802C9.88913 3.08971 7.88867 3.81939 6.29826 5.14236C4.70785 6.46534 3.62619 8.29953 3.23808 10.3315C2.84997 12.3635 3.1795 14.4673 4.17038 16.2833L10.5094 5.83577H14.2946L14.2954 5.83502Z", fill: color }));
}
exports["default"] = hight;
//# sourceMappingURL=hight.js.map